/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/countries';
import './gb/model';
import './us/common';
import './au/common';
import './jp/common';
import './fr/model';
import './ie/model';
import './es/model';
import './pt/model';
import './common';
import '../../legalentities/verification/verification';
import '../../common/location';
import './ca/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "model": {
                "nested": {
                  "Business": {
                    "fields": {
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "gbBusiness": {
                        "type": ".squareup.onboard.activation.gb.model.Business",
                        "id": 2
                      },
                      "usBusiness": {
                        "type": ".squareup.onboard.activation.us.common.Company",
                        "id": 3
                      },
                      "auBusiness": {
                        "type": ".squareup.onboard.activation.au.common.Company",
                        "id": 4
                      },
                      "jpBusiness": {
                        "type": ".squareup.onboard.activation.jp.common.Company",
                        "id": 5
                      },
                      "frBusiness": {
                        "type": ".squareup.onboard.activation.fr.model.Business",
                        "id": 6
                      },
                      "ieBusiness": {
                        "type": ".squareup.onboard.activation.ie.model.Business",
                        "id": 7
                      },
                      "esBusiness": {
                        "type": ".squareup.onboard.activation.es.model.Business",
                        "id": 8
                      },
                      "ptBusiness": {
                        "type": ".squareup.onboard.activation.pt.model.Business",
                        "id": 9
                      }
                    },
                    "nested": {
                      "country_specific_info": {
                        "oneof": ["gbBusiness", "usBusiness", "auBusiness", "jpBusiness", "frBusiness", "ieBusiness", "esBusiness", "ptBusiness"]
                      }
                    }
                  },
                  "Persona": {
                    "fields": {
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": ".squareup.onboard.activation.common.Name",
                        "id": 3,
                        "rule": "optional"
                      },
                      "birthDate": {
                        "type": ".squareup.onboard.activation.common.BirthDate",
                        "id": 5,
                        "rule": "optional"
                      },
                      "redacted": {
                        "type": "bool",
                        "id": 12,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "email": {
                        "type": "string",
                        "id": 15,
                        "rule": "optional"
                      },
                      "leNodeToken": {
                        "type": "string",
                        "id": 16,
                        "rule": "optional"
                      },
                      "primaryIndividual": {
                        "type": "bool",
                        "id": 17,
                        "rule": "optional"
                      },
                      "beneficialOwnerRole": {
                        "type": ".squareup.onboard.activation.common.BeneficialOwnerRole",
                        "id": 18,
                        "rule": "optional"
                      },
                      "incorrect": {
                        "type": "bool",
                        "id": 19,
                        "rule": "optional"
                      },
                      "incorrectReason": {
                        "type": "string",
                        "id": 20,
                        "rule": "optional"
                      },
                      "beneficialOwnerRemoved": {
                        "type": "bool",
                        "id": 21,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "creditHeaderOptIn": {
                        "type": "bool",
                        "id": 22,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "dvsHeaderOptIn": {
                        "type": "bool",
                        "id": 23,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "leNodeStatus": {
                        "type": ".squareup.legalentities.verification.VerificationSignal.IdentityVerification.Decision",
                        "id": 24,
                        "rule": "optional"
                      },
                      "addressToken": {
                        "type": "string",
                        "id": 2
                      },
                      "globalAddress": {
                        "type": ".squareup.common.location.GlobalAddress",
                        "id": 200
                      },
                      "phoneNumber": {
                        "type": "string",
                        "id": 4
                      },
                      "phoneObject": {
                        "type": ".squareup.common.location.Phone",
                        "id": 25
                      },
                      "gbPersona": {
                        "type": ".squareup.onboard.activation.gb.model.Persona",
                        "id": 6
                      },
                      "usPersona": {
                        "type": ".squareup.onboard.activation.us.common.Persona",
                        "id": 7
                      },
                      "caPersona": {
                        "type": ".squareup.onboard.activation.ca.common.Persona",
                        "id": 8
                      },
                      "auPersona": {
                        "type": ".squareup.onboard.activation.au.common.Persona",
                        "id": 9
                      },
                      "jpPersona": {
                        "type": ".squareup.onboard.activation.jp.common.Persona",
                        "id": 10
                      },
                      "frPersona": {
                        "type": ".squareup.onboard.activation.fr.model.Persona",
                        "id": 11
                      },
                      "iePersona": {
                        "type": ".squareup.onboard.activation.ie.model.Persona",
                        "id": 14
                      }
                    },
                    "nested": {
                      "address": {
                        "oneof": ["addressToken", "globalAddress"]
                      },
                      "phone": {
                        "oneof": ["phoneNumber", "phoneObject"]
                      },
                      "country_specific_info": {
                        "oneof": ["gbPersona", "usPersona", "caPersona", "auPersona", "jpPersona", "frPersona", "iePersona"]
                      }
                    }
                  },
                  "BankAccount": {
                    "fields": {
                      "countryCode": {
                        "type": ".squareup.common.countries.Country",
                        "id": 1,
                        "rule": "optional"
                      },
                      "accountName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "accountNumber": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "accountType": {
                        "type": ".squareup.onboard.activation.common.BankAccountType",
                        "id": 4,
                        "rule": "optional"
                      },
                      "gbBank": {
                        "type": ".squareup.onboard.activation.gb.model.Bank",
                        "id": 5
                      },
                      "frBank": {
                        "type": ".squareup.onboard.activation.fr.model.Bank",
                        "id": 6
                      }
                    },
                    "nested": {
                      "country_specific_info": {
                        "oneof": ["gbBank", "frBank"]
                      }
                    }
                  },
                  "Document": {
                    "fields": {
                      "auDocument": {
                        "type": ".squareup.onboard.activation.au.common.Document",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.model?.nested?.Business && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.model?.nested?.Persona && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.model?.nested?.BankAccount && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.model?.nested?.Document) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Business @ squareup/onboard/activation/model.proto at 21:1
 */
export const Business = $root.lookupType('squareup.onboard.activation.model.Business');
fixType(Business);
Builder.createAndAttachToType(Business);
/**
 * The persona message is used for any person legally associated to a business, which means the primary account holder
 * and beneficial owners, business partners, etc.
 *
 * SOURCE Persona @ squareup/onboard/activation/model.proto at 39:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.model.Persona');
fixType(Persona);
Builder.createAndAttachToType(Persona);
/**
 * SOURCE BankAccount @ squareup/onboard/activation/model.proto at 102:1
 */
export const BankAccount = $root.lookupType('squareup.onboard.activation.model.BankAccount');
fixType(BankAccount);
Builder.createAndAttachToType(BankAccount);
/**
 * SOURCE Document @ squareup/onboard/activation/model.proto at 118:1
 */
export const Document = $root.lookupType('squareup.onboard.activation.model.Document');
fixType(Document);
Builder.createAndAttachToType(Document);